/**
 * US-049 — GENERATED resource-scoped permission catalog (139 keys).
 * Source of truth: backend/scripts/us049-derivation.json (validated derivation).
 * DO NOT EDIT BY HAND — regenerate with: npx tsx backend/scripts/gen-catalog.ts
 *
 * Ships DARK (additive, Phase 0): added ALONGSIDE the legacy 37 keys; enforcement
 * still reads legacy keys. The derived defaults reproduce today's coarse policy in
 * 139 keys (AC6) — NOT minimum-necessary; the tightening pass is US-051.
 * Re-exported from ./definitions so the registry (Object.values(defs)) collects them.
 */
import { Permission } from "./Permission";

export const perm_adl_record_delete = new Permission({
  key: "adl-record:delete",
  scope: "facility",
  phi: true,
  label: "Delete adl record",
  category: "Resource (adl-record)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_adl_record_read = new Permission({
  key: "adl-record:read",
  scope: "facility",
  phi: true,
  label: "View adl record",
  category: "Resource (adl-record)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_adl_record_write = new Permission({
  key: "adl-record:write",
  scope: "facility",
  phi: true,
  label: "Edit adl record",
  category: "Resource (adl-record)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_analytics_read = new Permission({
  key: "analytics:read",
  scope: "org",
  phi: false,
  label: "View analytics",
  category: "Resource (analytics)",
  defaults: {},
});

export const perm_analytics_write = new Permission({
  key: "analytics:write",
  scope: "org",
  phi: false,
  label: "Edit analytics",
  category: "Resource (analytics)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_appointment_form_rule_read = new Permission({
  key: "appointment-form-rule:read",
  scope: "facility",
  phi: true,
  label: "View appointment form rule",
  category: "Resource (appointment-form-rule)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_appointment_form_rule_write = new Permission({
  key: "appointment-form-rule:write",
  scope: "facility",
  phi: true,
  label: "Edit appointment form rule",
  category: "Resource (appointment-form-rule)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_appointment_type_definition_read = new Permission({
  key: "appointment-type-definition:read",
  scope: "facility",
  phi: true,
  label: "View appointment type definition",
  category: "Resource (appointment-type-definition)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_appointment_type_definition_write = new Permission({
  key: "appointment-type-definition:write",
  scope: "facility",
  phi: true,
  label: "Edit appointment type definition",
  category: "Resource (appointment-type-definition)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_appointment_delete = new Permission({
  key: "appointment:delete",
  scope: "facility",
  phi: true,
  label: "Delete appointment",
  category: "Resource (appointment)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_appointment_force_complete = new Permission({
  key: "appointment:force-complete",
  scope: "facility",
  phi: true,
  label: "Force complete appointment",
  category: "Resource (appointment)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_appointment_read = new Permission({
  key: "appointment:read",
  scope: "facility",
  phi: true,
  label: "View appointment",
  category: "Resource (appointment)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_appointment_write = new Permission({
  key: "appointment:write",
  scope: "facility",
  phi: true,
  label: "Edit appointment",
  category: "Resource (appointment)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_audit_grant_read = new Permission({
  key: "audit-grant:read",
  scope: "facility",
  phi: false,
  label: "View audit grant",
  category: "Resource (audit-grant)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
    },
});

export const perm_audit_grant_revoke = new Permission({
  key: "audit-grant:revoke",
  scope: "facility",
  phi: false,
  label: "Revoke audit grant",
  category: "Resource (audit-grant)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_audit_grant_revoke_all = new Permission({
  key: "audit-grant:revoke-all",
  scope: "facility",
  phi: false,
  label: "Revoke all audit grant",
  category: "Resource (audit-grant)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_audit_grant_write = new Permission({
  key: "audit-grant:write",
  scope: "facility",
  phi: false,
  label: "Edit audit grant",
  category: "Resource (audit-grant)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
    },
});

export const perm_audit_log_read = new Permission({
  key: "audit-log:read",
  scope: "platform",
  phi: false,
  label: "View audit log",
  category: "Resource (audit-log)",
  defaults: {
      "role:audit:admin": true,
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_audit_request_approve = new Permission({
  key: "audit-request:approve",
  scope: "facility",
  phi: false,
  label: "Approve audit request",
  category: "Resource (audit-request)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_audit_request_deny = new Permission({
  key: "audit-request:deny",
  scope: "facility",
  phi: false,
  label: "Deny audit request",
  category: "Resource (audit-request)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_audit_request_read = new Permission({
  key: "audit-request:read",
  scope: "facility",
  phi: false,
  label: "View audit request",
  category: "Resource (audit-request)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_audit_request_write = new Permission({
  key: "audit-request:write",
  scope: "facility",
  phi: false,
  label: "Edit audit request",
  category: "Resource (audit-request)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_audit_read = new Permission({
  key: "audit:read",
  scope: "facility",
  phi: false,
  label: "View audit",
  category: "Resource (audit)",
  defaults: {
      "role:audit:admin": true,
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_audit_write = new Permission({
  key: "audit:write",
  scope: "facility",
  phi: false,
  label: "Edit audit",
  category: "Resource (audit)",
  defaults: {
      "role:audit:admin": true,
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_auditor_group_read = new Permission({
  key: "auditor-group:read",
  scope: "platform",
  phi: false,
  label: "View auditor group",
  category: "Resource (auditor-group)",
  defaults: {
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_auditor_group_write = new Permission({
  key: "auditor-group:write",
  scope: "platform",
  phi: false,
  label: "Edit auditor group",
  category: "Resource (auditor-group)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_auditor_invitation_approve = new Permission({
  key: "auditor-invitation:approve",
  scope: "platform",
  phi: false,
  label: "Approve auditor invitation",
  category: "Resource (auditor-invitation)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_auditor_invitation_deny = new Permission({
  key: "auditor-invitation:deny",
  scope: "platform",
  phi: false,
  label: "Deny auditor invitation",
  category: "Resource (auditor-invitation)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_auditor_invitation_read = new Permission({
  key: "auditor-invitation:read",
  scope: "platform",
  phi: false,
  label: "View auditor invitation",
  category: "Resource (auditor-invitation)",
  defaults: {
      "role:audit:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_auditor_invitation_write = new Permission({
  key: "auditor-invitation:write",
  scope: "platform",
  phi: false,
  label: "Edit auditor invitation",
  category: "Resource (auditor-invitation)",
  defaults: {
      "role:audit:admin": true,
      "role:platform:admin": true,
    },
});

export const perm_automation_manage = new Permission({
  key: "automation:manage",
  scope: "facility",
  phi: false,
  label: "Manage automation",
  category: "Resource (automation)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_bed_check_config_read = new Permission({
  key: "bed-check-config:read",
  scope: "facility",
  phi: false,
  label: "View bed check config",
  category: "Resource (bed-check-config)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_bed_check_config_write = new Permission({
  key: "bed-check-config:write",
  scope: "facility",
  phi: false,
  label: "Edit bed check config",
  category: "Resource (bed-check-config)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_bed_check_round_read = new Permission({
  key: "bed-check-round:read",
  scope: "facility",
  phi: true,
  label: "View bed check round",
  category: "Resource (bed-check-round)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_bed_check_round_write = new Permission({
  key: "bed-check-round:write",
  scope: "facility",
  phi: true,
  label: "Edit bed check round",
  category: "Resource (bed-check-round)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_billing_pack_read = new Permission({
  key: "billing-pack:read",
  scope: "facility",
  phi: true,
  label: "View billing pack",
  category: "Resource (billing-pack)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_billing_pack_write = new Permission({
  key: "billing-pack:write",
  scope: "facility",
  phi: true,
  label: "Edit billing pack",
  category: "Resource (billing-pack)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_calendar_event_read = new Permission({
  key: "calendar-event:read",
  scope: "facility",
  phi: true,
  label: "View calendar event",
  category: "Resource (calendar-event)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_calendar_event_write = new Permission({
  key: "calendar-event:write",
  scope: "facility",
  phi: true,
  label: "Edit calendar event",
  category: "Resource (calendar-event)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_care_note_delete = new Permission({
  key: "care-note:delete",
  scope: "facility",
  phi: true,
  label: "Delete care note",
  category: "Resource (care-note)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_care_note_read = new Permission({
  key: "care-note:read",
  scope: "facility",
  phi: true,
  label: "View care note",
  category: "Resource (care-note)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_care_note_write = new Permission({
  key: "care-note:write",
  scope: "facility",
  phi: true,
  label: "Edit care note",
  category: "Resource (care-note)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_care_plan_delete = new Permission({
  key: "care-plan:delete",
  scope: "facility",
  phi: true,
  label: "Delete care plan",
  category: "Resource (care-plan)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_care_plan_document = new Permission({
  key: "care-plan:document",
  scope: "facility",
  phi: true,
  label: "Document care plan",
  category: "Resource (care-plan)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_care_plan_read = new Permission({
  key: "care-plan:read",
  scope: "facility",
  phi: true,
  label: "View care plan",
  category: "Resource (care-plan)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_care_plan_write = new Permission({
  key: "care-plan:write",
  scope: "facility",
  phi: true,
  label: "Edit care plan",
  category: "Resource (care-plan)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_case_template_read = new Permission({
  key: "case-template:read",
  scope: "facility",
  phi: true,
  label: "View case template",
  category: "Resource (case-template)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_case_template_write = new Permission({
  key: "case-template:write",
  scope: "facility",
  phi: true,
  label: "Edit case template",
  category: "Resource (case-template)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_case_close = new Permission({
  key: "case:close",
  scope: "facility",
  phi: true,
  label: "Close case",
  category: "Resource (case)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_case_read = new Permission({
  key: "case:read",
  scope: "facility",
  phi: true,
  label: "View case",
  category: "Resource (case)",
  defaults: {
      "role:audit:admin": true,
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_case_write = new Permission({
  key: "case:write",
  scope: "facility",
  phi: true,
  label: "Edit case",
  category: "Resource (case)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_emergency_contact_read = new Permission({
  key: "emergency-contact:read",
  scope: "facility",
  phi: true,
  label: "View emergency contact",
  category: "Resource (emergency-contact)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_emergency_contact_write = new Permission({
  key: "emergency-contact:write",
  scope: "facility",
  phi: true,
  label: "Edit emergency contact",
  category: "Resource (emergency-contact)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_employee_read = new Permission({
  key: "employee:read",
  scope: "facility",
  phi: false,
  label: "View employee",
  category: "Resource (employee)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_employee_write = new Permission({
  key: "employee:write",
  scope: "facility",
  phi: false,
  label: "Edit employee",
  category: "Resource (employee)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_external_provider_manage = new Permission({
  key: "external-provider:manage",
  scope: "facility",
  phi: true,
  label: "Manage external provider",
  category: "Resource (external-provider)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_external_provider_read = new Permission({
  key: "external-provider:read",
  scope: "facility",
  phi: true,
  label: "View external provider",
  category: "Resource (external-provider)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_external_provider_verify_npi = new Permission({
  key: "external-provider:verify-npi",
  scope: "facility",
  phi: true,
  label: "Verify npi external provider",
  category: "Resource (external-provider)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_external_provider_write = new Permission({
  key: "external-provider:write",
  scope: "facility",
  phi: true,
  label: "Edit external provider",
  category: "Resource (external-provider)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_facility_read = new Permission({
  key: "facility:read",
  scope: "facility",
  phi: false,
  label: "View facility",
  category: "Resource (facility)",
  defaults: {
      "role:audit:admin": true,
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_facility_write = new Permission({
  key: "facility:write",
  scope: "facility",
  phi: false,
  label: "Edit facility",
  category: "Resource (facility)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_form_requirement_read = new Permission({
  key: "form-requirement:read",
  scope: "facility",
  phi: true,
  label: "View form requirement",
  category: "Resource (form-requirement)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_form_requirement_waive = new Permission({
  key: "form-requirement:waive",
  scope: "facility",
  phi: true,
  label: "Waive form requirement",
  category: "Resource (form-requirement)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_form_requirement_write = new Permission({
  key: "form-requirement:write",
  scope: "facility",
  phi: true,
  label: "Edit form requirement",
  category: "Resource (form-requirement)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_form_submission_read = new Permission({
  key: "form-submission:read",
  scope: "facility",
  phi: true,
  label: "View form submission",
  category: "Resource (form-submission)",
  defaults: {
      "role:audit:admin": true,
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_form_submission_write = new Permission({
  key: "form-submission:write",
  scope: "facility",
  phi: true,
  label: "Edit form submission",
  category: "Resource (form-submission)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_form_template_duplicate = new Permission({
  key: "form-template:duplicate",
  scope: "org",
  phi: false,
  label: "Duplicate form template",
  category: "Resource (form-template)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_form_template_publish = new Permission({
  key: "form-template:publish",
  scope: "org",
  phi: false,
  label: "Publish form template",
  category: "Resource (form-template)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_form_template_read = new Permission({
  key: "form-template:read",
  scope: "org",
  phi: false,
  label: "View form template",
  category: "Resource (form-template)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_form_template_write = new Permission({
  key: "form-template:write",
  scope: "org",
  phi: false,
  label: "Edit form template",
  category: "Resource (form-template)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_group_home_read = new Permission({
  key: "group-home:read",
  scope: "platform",
  phi: false,
  label: "View group home",
  category: "Resource (group-home)",
  defaults: {
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_group_home_write = new Permission({
  key: "group-home:write",
  scope: "platform",
  phi: false,
  label: "Edit group home",
  category: "Resource (group-home)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_holiday_read = new Permission({
  key: "holiday:read",
  scope: "org",
  phi: false,
  label: "View holiday",
  category: "Resource (holiday)",
  defaults: {},
});

export const perm_holiday_write = new Permission({
  key: "holiday:write",
  scope: "org",
  phi: false,
  label: "Edit holiday",
  category: "Resource (holiday)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_incident_delete = new Permission({
  key: "incident:delete",
  scope: "facility",
  phi: true,
  label: "Delete incident",
  category: "Resource (incident)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_incident_read = new Permission({
  key: "incident:read",
  scope: "facility",
  phi: true,
  label: "View incident",
  category: "Resource (incident)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_incident_report = new Permission({
  key: "incident:report",
  scope: "facility",
  phi: true,
  label: "Report incident",
  category: "Resource (incident)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_incident_write = new Permission({
  key: "incident:write",
  scope: "facility",
  phi: true,
  label: "Edit incident",
  category: "Resource (incident)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_invitation_read = new Permission({
  key: "invitation:read",
  scope: "org",
  phi: false,
  label: "View invitation",
  category: "Resource (invitation)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_invitation_write = new Permission({
  key: "invitation:write",
  scope: "org",
  phi: false,
  label: "Edit invitation",
  category: "Resource (invitation)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_legal_document_publish = new Permission({
  key: "legal-document:publish",
  scope: "org",
  phi: false,
  label: "Publish legal document",
  category: "Resource (legal-document)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_legal_document_read = new Permission({
  key: "legal-document:read",
  scope: "org",
  phi: false,
  label: "View legal document",
  category: "Resource (legal-document)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_legal_document_write = new Permission({
  key: "legal-document:write",
  scope: "org",
  phi: false,
  label: "Edit legal document",
  category: "Resource (legal-document)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
    },
});

export const perm_medication_administer = new Permission({
  key: "medication:administer",
  scope: "facility",
  phi: true,
  label: "Administer medication",
  category: "Resource (medication)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_medication_read = new Permission({
  key: "medication:read",
  scope: "facility",
  phi: true,
  label: "View medication",
  category: "Resource (medication)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_medication_write = new Permission({
  key: "medication:write",
  scope: "facility",
  phi: true,
  label: "Edit medication",
  category: "Resource (medication)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_notification_read = new Permission({
  key: "notification:read",
  scope: "facility",
  phi: false,
  label: "View notification",
  category: "Resource (notification)",
  defaults: {},
});

export const perm_notification_write = new Permission({
  key: "notification:write",
  scope: "facility",
  phi: false,
  label: "Edit notification",
  category: "Resource (notification)",
  defaults: {},
});

export const perm_permission_read = new Permission({
  key: "permission:read",
  scope: "platform",
  phi: false,
  label: "View permission",
  category: "Resource (permission)",
  defaults: {
      "role:audit:admin": true,
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_permission_write = new Permission({
  key: "permission:write",
  scope: "platform",
  phi: false,
  label: "Edit permission",
  category: "Resource (permission)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_pharmacy_partner_read = new Permission({
  key: "pharmacy-partner:read",
  scope: "platform",
  phi: false,
  label: "View pharmacy partner",
  category: "Resource (pharmacy-partner)",
  defaults: {
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_pharmacy_partner_write = new Permission({
  key: "pharmacy-partner:write",
  scope: "platform",
  phi: false,
  label: "Edit pharmacy partner",
  category: "Resource (pharmacy-partner)",
  defaults: {
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_platform_ops_read = new Permission({
  key: "platform-ops:read",
  scope: "platform",
  phi: false,
  label: "View platform ops",
  category: "Resource (platform-ops)",
  defaults: {
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_request_read = new Permission({
  key: "request:read",
  scope: "org",
  phi: false,
  label: "View request",
  category: "Resource (request)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_request_review = new Permission({
  key: "request:review",
  scope: "org",
  phi: false,
  label: "Review request",
  category: "Resource (request)",
  defaults: {
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_request_write = new Permission({
  key: "request:write",
  scope: "org",
  phi: false,
  label: "Edit request",
  category: "Resource (request)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_resident_absence_read = new Permission({
  key: "resident-absence:read",
  scope: "facility",
  phi: true,
  label: "View resident absence",
  category: "Resource (resident-absence)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_resident_absence_write = new Permission({
  key: "resident-absence:write",
  scope: "facility",
  phi: true,
  label: "Edit resident absence",
  category: "Resource (resident-absence)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_resident_directory_read = new Permission({
  key: "resident-directory:read",
  scope: "facility",
  phi: true,
  label: "View resident directory",
  category: "Resource (resident-directory)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_resident_directory_write = new Permission({
  key: "resident-directory:write",
  scope: "facility",
  phi: true,
  label: "Edit resident directory",
  category: "Resource (resident-directory)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_resident_document_read_legal = new Permission({
  key: "resident-document:read-legal",
  scope: "facility",
  phi: true,
  label: "Read legal resident document",
  category: "Resource (resident-document)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_resident_transfer_accept = new Permission({
  key: "resident-transfer:accept",
  scope: "facility",
  phi: true,
  label: "Accept resident transfer",
  category: "Resource (resident-transfer)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_resident_transfer_read = new Permission({
  key: "resident-transfer:read",
  scope: "facility",
  phi: true,
  label: "View resident transfer",
  category: "Resource (resident-transfer)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_resident_archive = new Permission({
  key: "resident:archive",
  scope: "facility",
  phi: true,
  label: "Archive resident",
  category: "Resource (resident)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_resident_deceased = new Permission({
  key: "resident:deceased",
  scope: "facility",
  phi: true,
  label: "Deceased resident",
  category: "Resource (resident)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_resident_read = new Permission({
  key: "resident:read",
  scope: "facility",
  phi: true,
  label: "View resident",
  category: "Resource (resident)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_resident_ssn_read = new Permission({
  key: "resident:ssn-read",
  scope: "facility",
  phi: true,
  label: "Ssn read resident",
  category: "Resource (resident)",
  defaults: {
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_resident_transfer = new Permission({
  key: "resident:transfer",
  scope: "facility",
  phi: true,
  label: "Transfer resident",
  category: "Resource (resident)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_resident_write = new Permission({
  key: "resident:write",
  scope: "facility",
  phi: true,
  label: "Edit resident",
  category: "Resource (resident)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_role_read = new Permission({
  key: "role:read",
  scope: "platform",
  phi: false,
  label: "View role",
  category: "Resource (role)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_role_write = new Permission({
  key: "role:write",
  scope: "platform",
  phi: false,
  label: "Edit role",
  category: "Resource (role)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_rule_bundle_application_read = new Permission({
  key: "rule-bundle-application:read",
  scope: "facility",
  phi: true,
  label: "View rule bundle application",
  category: "Resource (rule-bundle-application)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_rule_bundle_application_write = new Permission({
  key: "rule-bundle-application:write",
  scope: "facility",
  phi: true,
  label: "Edit rule bundle application",
  category: "Resource (rule-bundle-application)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_rule_bundle_adopt = new Permission({
  key: "rule-bundle:adopt",
  scope: "org",
  phi: false,
  label: "Adopt rule bundle",
  category: "Resource (rule-bundle)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_rule_bundle_import = new Permission({
  key: "rule-bundle:import",
  scope: "org",
  phi: false,
  label: "Import rule bundle",
  category: "Resource (rule-bundle)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_rule_bundle_new_version = new Permission({
  key: "rule-bundle:new-version",
  scope: "org",
  phi: false,
  label: "New version rule bundle",
  category: "Resource (rule-bundle)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_rule_bundle_publish = new Permission({
  key: "rule-bundle:publish",
  scope: "org",
  phi: false,
  label: "Publish rule bundle",
  category: "Resource (rule-bundle)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_rule_bundle_read = new Permission({
  key: "rule-bundle:read",
  scope: "org",
  phi: false,
  label: "View rule bundle",
  category: "Resource (rule-bundle)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
    },
});

export const perm_rule_bundle_write = new Permission({
  key: "rule-bundle:write",
  scope: "org",
  phi: false,
  label: "Edit rule bundle",
  category: "Resource (rule-bundle)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_shift_manage = new Permission({
  key: "shift:manage",
  scope: "facility",
  phi: true,
  label: "Manage shift",
  category: "Resource (shift)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_shift_read = new Permission({
  key: "shift:read",
  scope: "facility",
  phi: true,
  label: "View shift",
  category: "Resource (shift)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_shift_write = new Permission({
  key: "shift:write",
  scope: "facility",
  phi: true,
  label: "Edit shift",
  category: "Resource (shift)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_subscription_read = new Permission({
  key: "subscription:read",
  scope: "platform",
  phi: false,
  label: "View subscription",
  category: "Resource (subscription)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_subscription_write = new Permission({
  key: "subscription:write",
  scope: "platform",
  phi: false,
  label: "Edit subscription",
  category: "Resource (subscription)",
  defaults: {
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_training_assignment_read = new Permission({
  key: "training-assignment:read",
  scope: "facility",
  phi: false,
  label: "View training assignment",
  category: "Resource (training-assignment)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_training_assignment_write = new Permission({
  key: "training-assignment:write",
  scope: "facility",
  phi: false,
  label: "Edit training assignment",
  category: "Resource (training-assignment)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_training_certification_read = new Permission({
  key: "training-certification:read",
  scope: "facility",
  phi: false,
  label: "View training certification",
  category: "Resource (training-certification)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_training_completion_read = new Permission({
  key: "training-completion:read",
  scope: "facility",
  phi: false,
  label: "View training completion",
  category: "Resource (training-completion)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
    },
});

export const perm_training_completion_write = new Permission({
  key: "training-completion:write",
  scope: "facility",
  phi: false,
  label: "Edit training completion",
  category: "Resource (training-completion)",
  defaults: {},
});

export const perm_training_material_read = new Permission({
  key: "training-material:read",
  scope: "facility",
  phi: false,
  label: "View training material",
  category: "Resource (training-material)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_training_material_write = new Permission({
  key: "training-material:write",
  scope: "facility",
  phi: false,
  label: "Edit training material",
  category: "Resource (training-material)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_user_role_assign = new Permission({
  key: "user-role:assign",
  scope: "platform",
  phi: false,
  label: "Assign user role",
  category: "Resource (user-role)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:platform:admin": true,
      "role:platform:manager": true,
    },
});

export const perm_user_read = new Permission({
  key: "user:read",
  scope: "platform",
  phi: false,
  label: "View user",
  category: "Resource (user)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_user_write = new Permission({
  key: "user:write",
  scope: "platform",
  phi: false,
  label: "Edit user",
  category: "Resource (user)",
  defaults: {
      "role:platform:admin": true,
    },
});

export const perm_vital_sign_manage = new Permission({
  key: "vital-sign:manage",
  scope: "facility",
  phi: true,
  label: "Manage vital sign",
  category: "Resource (vital-sign)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:medical": true,
    },
});

export const perm_vital_sign_read = new Permission({
  key: "vital-sign:read",
  scope: "facility",
  phi: true,
  label: "View vital sign",
  category: "Resource (vital-sign)",
  defaults: {
      "role:audit:external": true,
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_vital_sign_write = new Permission({
  key: "vital-sign:write",
  scope: "facility",
  phi: true,
  label: "Edit vital sign",
  category: "Resource (vital-sign)",
  defaults: {
      "role:facility:manager": true,
      "role:org:admin": true,
      "role:staff:care": true,
      "role:staff:medical": true,
    },
});

export const perm_webhook_read = new Permission({
  key: "webhook:read",
  scope: "org",
  phi: false,
  label: "View webhook",
  category: "Resource (webhook)",
  defaults: {
      "role:org:admin": true,
    },
});

export const perm_webhook_write = new Permission({
  key: "webhook:write",
  scope: "org",
  phi: false,
  label: "Edit webhook",
  category: "Resource (webhook)",
  defaults: {
      "role:org:admin": true,
    },
});
